module.exports = __webpack_public_path__ + "static/epsilon-management-logo-ee0b9cb0f9bcb47ebd25d59fc9f71e29.png";